import { render, staticRenderFns } from "./CoachQuery.vue?vue&type=template&id=2a074016&lang=pug"
import script from "./CoachQuery.vue?vue&type=script&lang=js"
export * from "./CoachQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports